import { WidgetMarginsTheme } from "@xapp/stentor-chat-widget";
import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { ThemeBuilderSection } from "./ThemeBuilderSection";
import { WidgetLengthPickerLine } from "./WidgetLengthPickerLine";

export interface WidgetMarginPickerProps {
    readonly label?: string;
    readonly theme: WidgetMarginsTheme | undefined;
    readonly defaultTheme: WidgetMarginsTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<WidgetMarginsTheme>>;
}

const EMPTY_THEME: WidgetMarginsTheme = {};

const WidgetMarginPickerInner: FC<WidgetMarginPickerProps> = props => {
    const theme: WidgetMarginsTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: WidgetMarginsTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleTopChange = useOnChangeChildDispatch("top", onChange);
    const handleRightChange = useOnChangeChildDispatch("right", onChange);
    const handleBottomChange = useOnChangeChildDispatch("bottom", onChange);
    const handleLeftChange = useOnChangeChildDispatch("left", onChange);

    return (
        <ThemeBuilderSection heading={props.label ?? "Margin"} className="widget-size-picker">
            <WidgetLengthPickerLine label="Top" value={theme.top} defaultValue={defaultTheme.top} onChange={handleTopChange} />
            <WidgetLengthPickerLine label="Right" value={theme.right} defaultValue={defaultTheme.right} onChange={handleRightChange} />
            <WidgetLengthPickerLine label="Bottom" value={theme.bottom} defaultValue={defaultTheme.bottom} onChange={handleBottomChange} />
            <WidgetLengthPickerLine label="Left" value={theme.left} defaultValue={defaultTheme.left} onChange={handleLeftChange} />
        </ThemeBuilderSection>
    );
};

export const WidgetMarginPicker = React.memo(WidgetMarginPickerInner);